import { DomainInitPayload } from '@sxm-de/dev-kits/web-sdk/types';

interface UpdatePasswordFnPayload {
    password: string;
    identityId: string;
}

export type UpdatePasswordFn = (
    payload: UpdatePasswordFnPayload,
) => Promise<void>;

export function initUpdatePasswordFn({
    dependencies,
}: DomainInitPayload): UpdatePasswordFn {
    const { clientSdk } = dependencies;
    return async ({ password, identityId }: UpdatePasswordFnPayload) => {
        try {
            await clientSdk.user.updatePassword({
                newPassword: password,
                targetIdentityId: identityId,
            });
        } catch (error: any) {
            /**
             * TODO:
             * Log error to error logger (not analytics).
             */
            throw new Error('SYSTEM');
        }
    };
}
